{
  "common": {
    "actions": {
      "save": "Salva",
      "edit": "Modifica",
      "saveChanges": "Salva modifiche",
      "saveAndExit": "Salva ed esci",
      "cancel": "Annulla",
      "back": "Indietro",
      "delete": "Elimina",
      "reject": "Rifiuta",
      "accept": "Accetta",
      "add": "Aggiungi",
      "applyChanges": "Applica modifiche",
      "preview": "Anteprima",
      "close": "Chiudi",
      "revert": "Ripristina",
      "clickHere": "Clicca qui",
      "continue": "Continua",
      "export": "Esporta",
      "learnMore": "Scopri di più",
      "previous": "Precedente",
      "next": "Successivo",
      "complete": "Completa",
      "change": "Cambia"
    },
    "statuses": {
      "canceled": "Annullato",
      "rejected": "Rifiutato",
      "accepted": "Accettato",
      "success": "Successo",
      "failed": "Fallito",
      "required": "Obbligatorio",
      "open": "Aperto",
      "closed": "Chiuso",
      "imported": "Importato",
      "draft": "Bozza",
      "forReview": "In revisione",
      "forApproval": "In approvazione",
      "approved": "Approvato",
      "approvalDeclined": "Approvazione rifiutata",
      "effective": "Efficace",
      "superseded": "Sostituito"
    },
    "labels": {
      "archivedRegistryItem": "{{name}} (Archiviato)",
      "deactivatedUser": "{{name}} (Disattivato)",
      "name": "Nome",
      "type": "Tipo",
      "email": "E-mail",
      "password": "Password",
      "comments": "Commenti",
      "properties": "Proprietà",
      "assignedTo": "Assegnato a",
      "eventTitle": "Titolo evento",
      "eventId": "ID evento",
      "none": "Nessuno",
      "reason": "Motivo",
      "events": "Eventi",
      "created": "Creato",
      "lastModified": "Ultima modifica",
      "steps": "Passaggi",
      "fields": "Campi",
      "version": "Versione",
      "owner": "Proprietario",
      "eventType": "Tipo evento",
      "eventTypes": "Tipi evento",
      "taskStatus": "Stato attività",
      "createdBetween": "Creato tra",
      "due": "Scadenza",
      "status": "Stato",
      "owners": "Proprietari",
      "startDate": "Data di inizio",
      "endDate": "Data di fine",
      "risk": "Rischio",
      "severity": "Gravità",
      "ownerEmail": "E-mail del proprietario",
      "probability": "Probabilità",
      "product": "Prodotto",
      "products": "Prodotti",
      "rootCause": "Causa radice",
      "rootCauses": "Cause radice",
      "relatedRecords": "Relazioni",
      "source": "Fonte",
      "assignee": "Assegnatario",
      "description": "Descrizione",
      "visible": "Visibile",
      "required": "Obbligatorio",
      "title": "Titolo",
      "prefix": "Prefisso",
      "attachments": "Allegati",
      "resolution": "Risoluzione",
      "relatedTo": "Correlato a",
      "approvers": "Approvatori",
      "reviewers": "Revisori",
      "total": "Totale",
      "approvalDate": "Data approvazione",
      "id": "ID",
      "tags": "Tag",
      "emptyProducts": "Prodotti vuoti",
      "emptyRootCauses": "Cause radice vuote",
      "emptyTags": "Tag vuoti",
      "emptySeverities": "Gravità vuote",
      "emptyProbabilities": "Probabilità vuote",
      "suppliers": "Fornitori",
      "dueDate": "Data di scadenza",
      "currentDueDate": "Data di scadenza attuale",
      "newDueDate": "Nuova data di scadenza",
      "selectANewOwner": "Seleziona nuovo proprietario",
      "tasks": "Attività",
      "usersList": "Elenco utenti",
      "createdBefore": "Creato prima del",
      "createdAfter": "Creato dopo",
      "dueAfter": "Scadenza dopo",
      "dueBefore": "Scadenza prima del",
      "resolvedAfter": "Risolto dopo",
      "resolvedBefore": "Risolto prima del",
      "overdue": "In ritardo",
      "onTime": "In tempo",
      "integrationVariables": "Variabili di integrazione",
      "comment": "Commento",
      "currentOwner": "Proprietario attuale",
      "newOwner": "Nuovo proprietario",
      "defaultSections": "Sezioni predefinite",
      "formSteps": "Passaggi del modulo",
      "capturedIn": "Acquisito in",
      "inSection": "Nella sezione",
      "open": "Aperto",
      "canceled": "Annullato",
      "completed": "Completato",
      "templateOwner": "Proprietario del modello",
      "timeLimitDays": "Limite di tempo (giorni)",
      "validationStepTimeDelayDays": "Ritardo del passaggio di validazione (giorni)",
      "newTemplateOwner": "Nuovo proprietario del modello",
      "defaultContent": "Contenuto predefinito",
      "sectionWithPosition": "Sezione {{position}}",
      "back": "Indietro",
      "moveUp": "Sposta su",
      "moveDown": "Sposta giù",
      "yes": "Sì",
      "no": "No",
      "view": "Visualizza",
      "resolved": "Risolto",
      "closed": "Chiuso",
      "imported": "Importato",
      "manage": "Gestisci",
      "emptyState": "--",
      "order": "Ordine",
      "fullName": "Nome completo",
      "groups": "Gruppi",
      "taskName": "Nome attività",
      "approve": "Approva",
      "decline": "Rifiuta",
      "revert": "Ripristina",
      "eventClosed": "Evento chiuso",
      "stepCompleted": "Passaggio completato",
      "stepReverted": "Passaggio ripristinato",
      "eventReopened": "Evento riaperto",
      "reviewersAssigned": "Revisori assegnati!",
      "approversAssigned": "Approvatori assegnati!",
      "and": "e",
      "content": "Contenuto",
      "form": "Modulo",
      "validationWithType": "Validazione ({{type}})",
      "reopen": "Riapri",
      "qualityApproverRequired": "Approvatore qualità richiesto"
    },
    "placeholders": {
      "email": "E-mail...",
      "password": "Password...",
      "enterANumber": "Inserisci un numero",
      "writeAComment": "Scrivi un commento...",
      "searchFor": "Cerca {{domain}} da aggiungere...",
      "noResults": "Nessun risultato",
      "startTypingToSearchFor": "Inizia a digitare per cercare",
      "newestFirst": "Più recenti prima",
      "oldestFirst": "Più vecchi prima"
    },
    "errors": {
      "defaultErrorMessage": "Si è verificato un problema di comunicazione con il server.",
      "timeZoneMissingMessage": "Impossibile trovare il fuso orario dell'utente.",
      "invalidCredentials": "Credenziali non valide",
      "somethingHasGoneWrong": "Qualcosa è andato storto!",
      "currentCompanyRoleError": "Impossibile determinare il ruolo dell'utente nell'istanza attuale.",
      "failedToFetchEventDetails": "Impossibile recuperare i dettagli dell'evento.",
      "duplicateTitlesNotAllowed": "I titoli duplicati non sono consentiti. Usa titoli unici.",
      "invalidCharactersInTitle": "Caratteri non validi nel titolo: {{characters}}",
      "missingRequiredFieldsClickHere": "Mancano alcuni campi obbligatori nell'evento. Fai clic qui per vedere i campi obbligatori dell'evento.",
      "missingRequiredFieldsWithPrefix": "...evento. Fai clic qui per vedere i campi obbligatori dell'evento.",
      "invalidCharactersInTitlePrefix": "Caratteri non validi nel titolo:"
    },
    "notifications": {
      "fileReady": "File pronto",
      "preparingFileForDownload": "Preparazione file per il download",
      "error": "Errore",
      "userReassigned": "Utente riassegnato",
      "eventCreated": "Evento creato",
      "missingInformation": "Informazioni mancanti",
      "success": "Successo",
      "draftDeleted": "Bozza eliminata",
      "draftNotDeleted": "Bozza non eliminata",
      "ownerChanged": "Proprietario modificato",
      "ownerNotChanged": "Proprietario non modificato",
      "eventOpened": "Evento aperto",
      "eventNotOpened": "Evento non aperto",
      "eventUpdated": "Evento aggiornato",
      "eventNotUpdated": "Evento non aggiornato",
      "taskCompleted": "Attività completata",
      "taskNotCompleted": "Attività non completata",
      "failed": "Fallito",
      "tagsUpdated": "Tag aggiornati",
      "tagsNotUpdated": "Tag non aggiornati",
      "eventPropertiesUpdated": "Proprietà evento aggiornate",
      "newEventCreated": "Nuovo evento creato",
      "eventNotCreated": "Evento non creato",
      "couldNotRetrieveEventMetadata": "Impossibile recuperare i metadati dell'evento",
      "couldNotRetrieveGroups": "Impossibile recuperare i gruppi",
      "failedToFetchEventTemplateDetails": "Errore nel recupero del modello evento",
      "eventUpdateFailed": "Aggiornamento evento fallito",
      "revertedToDraft": "Riportato in bozza",
      "changesSaved": "Modifiche salvate",
      "failedToUpdateTask": "Impossibile aggiornare l'attività",
      "couldNotRetrieveTags": "Impossibile recuperare i tag",
      "couldNotRetrieveUsers": "Impossibile recuperare gli utenti",
      "reviewed": "Revisionato",
      "stepNotReviewed": "Passaggio non revisionato",
      "eventReassignmentFailed": "Riassegnazione evento fallita",
      "couldNotRetrieveEventTypes": "Impossibile recuperare i tipi di evento",
      "failedToFetchFormTemplateDetails": "Errore nel recupero del modello modulo",
      "formTemplateUpdateFailed": "Aggiornamento modello modulo fallito",
      "eventTemplateUpdated": "Modello evento aggiornato",
      "eventTemplateNotUpdated": "Modello evento non aggiornato",
      "newDraftCreated": "Nuova bozza creata",
      "creatingNewDraftFailed": "Creazione bozza fallita",
      "templateArchived": "Modello archiviato",
      "templateArchivingFailed": "Archiviazione modello fallita",
      "templateRestored": "Modello ripristinato",
      "templateRestoringFailed": "Ripristino modello fallito",
      "missingRequiredFields": "Campi obbligatori mancanti",
      "temporarilyUnableToRetrieveAllEventProperties": "Impossibile recuperare temporaneamente tutte le proprietà dell'evento",
      "reviewRequest": "Richiesta di revisione",
      "yourReviewIsRequired": "La tua revisione è richiesta",
      "fileReadyToDownloadPrefix": "Il file è ora disponibile per",
      "fileReadyToDownloadLinkText": "scaricare",
      "couldNotRetrieveSummaryFromAI": "Impossibile recuperare il riepilogo dal servizio IA",
      "propertiesUpdateForEvent": "Proprietà aggiornate per l'evento {{eventCode}}",
      "eventCreatedDesc": "\"{{eventCode}} | {{eventTitle}}\" è stato creato",
      "eventCreatedWithTitle": "\"{{title}}\" è stato creato",
      "tagsUpdatedDesc": "Tag per {{eventCode}} aggiornati con successo",
      "eventUpdatedToLatestTemplate": "L'evento è stato aggiornato all'ultimo modello di evento.",
      "eventNotUpdatedToLatestTemplate": "L'evento non è stato aggiornato all'ultimo modello di evento.",
      "draftSuccessfullyDeleted": "La bozza è stata eliminata correttamente",
      "failedToDeleteTheDraft": "Impossibile eliminare la bozza",
      "pleaseSaveTheEventTemplateFirst": "Salva prima il modello dell'evento",
      "wellLetYouKnowWhenFileIsReady": "Ti faremo sapere quando il file è pronto",
      "exportingEventCodeTitle": "Esportazione di {{code}} {{title}}",
      "ownerSuccessfullyChanged": "Proprietario di {{eventCode}} cambiato con successo",
      "theTeamHasBeenNotified": "Il team è stato informato. Aggiorna la pagina o riprova più tardi."
    },
    "filters": {
      "filterByOwner": "Filtra per proprietario...",
      "filterByCollaborator": "Filtra per collaboratore...",
      "filterByAssignee": "Filtra per assegnatario...",
      "filterByCreatedDate": "Filtra per data di creazione...",
      "filterByDueDate": "Filtra per data di scadenza...",
      "filterByResolvedDate": "Filtra per data di risoluzione...",
      "filterByDueStatus": "Filtra per scadenza...",
      "filterByProduct": "Filtra per prodotto...",
      "filterByRootCause": "Filtra per causa radice...",
      "filterByTags": "Filtra per tag...",
      "filterByProbability": "Filtra per probabilità...",
      "filterByNameEmailOrGroupName": "Filtra per nome, e-mail o gruppo...",
      "filterBySeverity": "Filtra per severità...",
      "searchRelatedRecords": "Filtra per relazioni...",
      "searchMore": "Cerca altro...",
      "filterByStatus": "Filtra per stato...",
      "filterByEventType": "Filtra per tipo di evento...",
      "approversAdded": "Approvatori aggiunti",
      "approversRemoved": "Approvatori rimossi",
      "reviewersAdded": "Revisori aggiunti",
      "reviewersRemoved": "Revisori rimossi",
      "reasonForRemovingTheUserType": "Motivo della rimozione dei {{userType}}..."
    },
    "tables": {
      "noMatchingEventsFound": "Nessun evento corrispondente trovato",
      "noMatchingTasksFound": "Nessuna attività corrispondente trovata"
    },
    "pagination": {
      "show": "Mostra",
      "showSpace": "Mostra ",
      "previousPage": "pagina precedente",
      "nextPage": "pagina successiva"
    },
    "exports": {
      "fileReady": "File pronto",
      "preparingFileForDownload": "Preparazione file per il download",
      "failedToExportTheFile": "Esportazione file fallita.",
      "xlsx": "XLSX",
      "pdf": "PDF"
    },
    "units": {
      "days": "giorni"
    },
    "debug": {
      "noFlagsReturnedInThisEnvironment": "Nessun flag restituito in questo ambiente",
      "knownFlags": "Flag noti",
      "rawLDFlagValues": "Valori grezzi dei flag LD"
    }
  },
  "templates": {
    "steps": {
      "dueDays": {
        "header": "Scadenza (giorni)",
        "tooltip": "Il numero di giorni dopo la creazione di un evento da questo modello prima che questo passaggio arrivi a scadenza. Il conto alla rovescia inizia al momento della creazione dell'evento.",
        "validation": {
          "range": "Inserisci un numero intero di giorni compreso tra 0 e 100000."
        }
      }
    },
    "labels": {
      "eventTemplates": "Modelli di evento",
      "templateStatus": "Stato modello",
      "templateOwner": "Proprietario modello",
      "defaultAssignee": "Assegnatario predefinito",
      "defaultEventOwner": "Proprietario evento predefinito",
      "defaultTimeLimit": "Limite tempo predefinito",
      "validationStepTimeDelay": "Ritardo fase di convalida",
      "timeLimitDays": "Limite tempo (giorni)",
      "validationStepTimeDelayDays": "Ritardo fase di convalida (giorni)",
      "defaultSections": "Sezioni predefinite",
      "formSteps": "Passaggi del modulo",
      "inSection": "Nella sezione"
    },
    "actions": {
      "editEventTemplate": "Modifica modello evento",
      "createTemplateDraft": "Crea bozza modello",
      "makeEffective": "Rendi efficace",
      "addStep": "Aggiungi passaggio",
      "deleteDraft": "Elimina bozza",
      "changeTemplateOwner": "Cambia proprietario modello",
      "createEventTemplate": "Crea modello evento",
      "renameStep": "Rinomina passaggio",
      "changeValidationStepType": "Cambia tipo fase convalida",
      "selectResolution": "Seleziona risoluzione",
      "updateTemplate": "Aggiorna modello",
      "deleteStep": "Elimina passaggio",
      "createTemplate": "Crea modello",
      "addSection": "Aggiungi sezione",
      "editContentTemplate": "Modifica modello di contenuto"
    },
    "statuses": {
      "draft": "Bozza",
      "effective": "Efficace",
      "archived": "Archiviato",
      "forApproval": "In approvazione",
      "approvalDeclined": "Approvazione rifiutata",
      "superseded": "Sostituito",
      "allActiveStatuses": "Tutti gli stati aperti"
    },
    "messages": {
      "eventTemplateCreated": "Modello evento creato",
      "templateCreatedWithTitle": "\"{{title}}\" è stato creato",
      "eventTemplateCreatedFailTitle": "Modello evento non creato",
      "makeEffectiveSuccessMessage": "Modello reso efficace",
      "eventTemplateUpdateFailTitle": "Modello non aggiornato",
      "changeEventTemplateOwnerSuccessMessage": "Proprietario modello aggiornato",
      "duplicatedStepNames": "Nomi dei passaggi duplicati!",
      "updatesHaveBeenMadeToThisTemplate": "Sono state apportate modifiche a questo modello",
      "pleaseChooseAResolution": "Seleziona una risoluzione per le seguenti modifiche al modello. Al momento non verrà applicata alcuna modifica al documento.",
      "aPrefixWillBeAutomaticallyAdded": "Un prefisso verrà aggiunto automaticamente a ogni evento creato.",
      "eachEventMustBeResolved": "Ogni evento deve essere risolto entro il numero di giorni indicato. È un valore predefinito e può essere modificato durante la creazione dell'evento.",
      "determinesHowManyDays": "Determina quanti giorni devono passare prima di poter completare l'approvazione del passaggio finale.",
      "templateSuccessfullyUpdated": "Modello aggiornato con successo",
      "failedToUpdateTheTemplate": "Impossibile aggiornare il modello:",
      "makeThisAResolutionSection": "Imposta come sezione di risoluzione",
      "contentTemplateNotCreated": "Modello di contenuto non creato",
      "formTemplateNotCreated": "Modello di modulo non creato",
      "editContentTemplate": "Modifica modello di contenuto",
      "editFormTemplate": "Modifica modello di modulo",
      "startBuildingYourForm": "Inizia a creare il tuo modulo",
      "makeThisTheValidationStep": "Imposta come passaggio di validazione",
      "onlyOneResolutionSectionAllowed": "È consentita solo una sezione di tipo \"Resolution\". Cambia prima il tipo dell'altra sezione.",
      "resolutionSectionDescription": "Una sezione di tipo \"Resolution\" verrà mostrata come casella selezionabile per confermare se il problema è stato risolto o meno.",
      "optionalQualityApproverHelper": "Per i passaggi in cui l'approvatore qualità è facoltativo, è richiesto almeno un altro approvatore."
    },
    "modals": {
      "makeEffectiveModalHeadingText": "Rendi modello efficace",
      "makeEffectiveModalSubText": "Inserisci la tua firma digitale per rendere efficace questo modello.",
      "deleteDraftConfirmationHeader": "Eliminare la bozza?",
      "deleteDraftConformationBody": "Sei sicuro? Le modifiche andranno perse.",
      "exportModalTitle": "Esporta event template",
      "exportModalSubText": "Qualio esporta gli event templates come PDF.",
      "exportCoverPageTitle": "Pagina di copertina",
      "exportCoverPageSubText": "Una pagina di copertina include le proprietà dell'event template come prima pagina dell'esportazione del template.",
      "exportIncludeCoverPage": "Includi pagina di copertina"
    },
    "fields": {
      "currentEventTemplateOwnerLabel": "Attuale",
      "reasonForChangeInputLabel": "Motivo della modifica",
      "reasonForChangePlaceholder": "Inserisci motivo per rendere efficace il modello..."
    },
    "helpText": {
      "templateFieldControlDescription": "Mostra i campi da raccogliere. I campi obbligatori verranno controllati alla chiusura dell'evento.",
      "templateFieldControlDescriptionForEventCapture": "Mostra i campi da raccogliere. Puoi specificare una fase del modulo per acquisire il campo.",
      "defaultAssigneeHelper": "Verrà assegnato un proprietario automaticamente alla creazione.",
      "defaultEventOwnerHelper": "Necessario per creare eventi automaticamente via integrazione.",
      "prefixHelpText": "Prefisso aggiunto automaticamente a ogni evento. Solo lettere e cifre.",
      "defaultTimeLimitDefaultHelpText": "Ogni evento deve essere risolto entro un certo numero di giorni.",
      "defaultTimeLimitEventDueDateHelpText": "La data di scadenza iniziale verrà calcolata su questo valore.",
      "validationStepTimeDelayHelpText": "Giorni necessari prima di poter completare l'approvazione finale."
    },
    "validation": {
      "emptyTitlesAreNotAllowed": "I titoli vuoti non sono consentiti",
      "duplicateTitlesAreNotAllowed": "I titoli duplicati non sono consentiti"
    },
    "ckeditor": {
      "insertCodeBlock": "Inserisci blocco di codice",
      "insertCodeBlockCaps": "INSERISCI BLOCCO DI CODICE",
      "paragraph": "Paragrafo",
      "heading1": "Intestazione 1",
      "heading2": "Intestazione 2",
      "heading3": "Intestazione 3",
      "heading4": "Intestazione 4",
      "normal": "Normale"
    },
    "content": {
      "resolveSection": "La sezione '{{sectionTitle}}' è contrassegnata per la rimozione, seleziona una risoluzione."
    }
  },
  "forms": {
    "labels": {
      "fieldTitle": "Titolo del campo",
      "helpText": "Testo di aiuto",
      "sectionFieldTitle": "Titolo della sezione",
      "sectionDescription": "Descrizione della sezione",
      "defaultContent": "Contenuto predefinito",
      "multiSelect": "Selezione multipla",
      "optionSectionLabel": "Opzioni",
      "reviewStep": "Passaggio di revisione"
    },
    "actions": {
      "completeForm": "Completa modulo",
      "addField": "Aggiungi campo",
      "addFormElement": "Aggiungi elemento modulo",
      "createNewField": "Crea nuovo campo",
      "chooseQualioResource": "Scegli risorsa Qualio",
      "addHelpText": "Aggiungi testo aiuto",
      "editHelpText": "Modifica testo aiuto",
      "addSectionDescription": "Aggiungi descrizione sezione",
      "editSectionDescription": "Modifica descrizione sezione",
      "addDefaultContent": "Aggiungi contenuto predefinito",
      "editDefaultContent": "Modifica contenuto predefinito",
      "addOption": "Aggiungi opzione",
      "startBuildingForm": "Inizia a costruire il modulo",
      "editForm": "Modifica modulo",
      "sendForReview": "Invia per revisione",
      "sendForApproval": "Invia per approvazione",
      "reassignStep": "Riassegna passaggio",
      "manageReviewers": "Gestisci revisori",
      "manageApprovers": "Gestisci approvatori",
      "revertToDraft": "Riporta in bozza",
      "markAsReviewed": "Segna come revisionato",
      "reassignStepAction": "Riassegna passaggio"
    },
    "messages": {
      "noFormElementAddedYet": "Nessun elemento del modulo aggiunto",
      "addFormElementToStartBuilding": "Aggiungi un elemento del modulo per iniziare a creare il tuo modulo",
      "formUpdateSuccessTitle": "Valori modulo aggiornati",
      "formUpdateSuccessMessage": "Modulo aggiornato con successo",
      "formUpdateFailedTitle": "Modulo non aggiornato",
      "formMissingMessage": "Impossibile trovare il modulo",
      "formPreviewWarning": "Anteprima del modulo",
      "formPreviewDuplicateLabelWarning": "Presenti etichette duplicate nel modulo.",
      "noFormYet": "Nessun modulo da visualizzare",
      "startFormCopy": "Inizia a costruire il modulo per raccogliere informazioni specifiche.",
      "approversUpdateSuccessTitle": "{{approverType}} aggiornati",
      "approversUpdateSuccessMessage": "{{approverType}} aggiornati con successo",
      "approversUpdateFailedTitle": "Aggiornamento {{approverType}} fallito",
      "approversUpdateFailedMessage": "Uno o più {{approverType}} non sono stati aggiornati.",
      "atLeastOneAssigneeRequiredMessage": "Necessario almeno un assegnatario",
      "removingActionedApproverErrorMessage": "Impossibile rimuovere un {{approverType}} che ha già agito",
      "reviewForm": "Revisiona \"{{formName}}\"",
      "disabledDeleteTooltip": "La visibilità è impostata nel modello.",
      "disableRequiredTooltip": "L'impostazione obbligatoria è gestita nel modello.",
      "pleaseMarkThisStepAsReviewed": "Segna questo passaggio come revisionato",
      "reviewersAdded": "Revisori aggiunti"
    },
    "fieldTypes": {
      "text": "Testo su una riga",
      "richText": "Paragrafo di testo avanzato",
      "date": "Data",
      "dropdown": "Menu a tendina",
      "boolean": "Sì / No",
      "numeric": "Numerico",
      "attachment": "Allegato",
      "document": "Documento",
      "event": "Evento",
      "supplier": "Fornitore",
      "user": "Utente",
      "section": "Sezione",
      "checkbox": "Caselle di controllo",
      "radio": "Pulsanti di opzione",
      "changeRequest": "Richiesta di modifica",
      "registry": "Registro",
      "designControls": "Controlli di progettazione",
      "training": "Formazione",
      "documentTemplates": "Modelli",
      "eventTemplates": "Modelli di evento",
      "task": "Attività"
    },
    "validation": {
      "optionValueRequired": "Valore opzione richiesto",
      "optionValueTooLarge": "Il valore deve essere inferiore a 512 caratteri",
      "optionValueUnique": "I nomi delle opzioni devono essere univoci",
      "requiredFieldHelper": "Campo richiesto per chiudere l'evento",
      "formContentInvalidError": "Contenuto del modulo non valido",
      "required": "Obbligatorio"
    },
    "statusChanges": {
      "sentForReview": "Inviato per revisione",
      "sentForApproval": "Inviato per approvazione",
      "revertedToDraft": "Riportato in bozza",
      "cannotSendForReview": "Impossibile inviare per revisione",
      "cannotSendForApproval": "Impossibile inviare per approvazione",
      "cannotRevertToDraft": "Impossibile riportare in bozza",
      "cannotUpdateTheForm": "Impossibile aggiornare il modulo",
      "wasSentForReview": "{{formTitle}} inviato per revisione",
      "wasSentForApproval": "{{formTitle}} inviato per approvazione",
      "wasRevertedToDraft": "è stato riportato in bozza"
    },
    "approvers": {
      "reviewers": "Revisori",
      "qualityApprovers": "Approvatori qualità",
      "otherApprovers": "Altri approvatori",
      "approverDeclinedStepOnDate": "{{approverName}} ha rifiutato questo passaggio il {{date}} con il seguente commento:"
    },
    "errors": {
      "cannotSendForApprovalMissingRequiredFields": "Campi obbligatori mancanti nell'evento",
      "pleaseAddApproversBeforeSubmitting": "Aggiungi gli approvatori prima di inviare.",
      "missingRequiredFieldsOnEvent": "Mancano campi obbligatori nell'evento.",
      "toViewTheRequiredEventFields": "per vedere i campi obbligatori."
    }
  },
  "events": {
    "labels": {
      "eventProperties": "Proprietà evento",
      "relatedEvents": "Eventi correlati",
      "relatedDocuments": "Documenti correlati",
      "sourceEvent": "Evento sorgente",
      "escalatedTo": "Escalation a",
      "relatedSuppliers": "Fornitori correlati",
      "events": "Eventi",
      "tasks": "Attività",
      "products": "Prodotti",
      "collaborators": "Collaboratori"
    },
    "actions": {
      "createEvent": "Crea evento",
      "editEvent": "Modifica evento",
      "openEvent": "Apri evento",
      "cancelEvent": "Annulla evento",
      "closeEarly": "Chiudi anticipatamente",
      "updateEvent": "Aggiorna evento",
      "updateTags": "Aggiorna tag",
      "escalateAndCreateNewEvent": "Escalation e crea nuovo evento",
      "exportEvent": "Esporta evento",
      "changeOwner": "Cambia proprietario",
      "changeDueDate": "Modifica data di scadenza",
      "updateEventProperties": "Aggiorna proprietà evento",
      "exportListAsXLSX": "Esporta elenco come XLSX",
      "exportListAsPDF": "Esporta elenco come PDF",
      "approveStep": "Approva passaggio",
      "declineStep": "Rifiuta passaggio",
      "reopenEvent": "Riapri evento",
      "closeEvent": "Chiudi evento"
    },
    "statuses": {
      "open": "Aperto",
      "closed": "Chiuso",
      "imported": "Importato",
      "rejected": "Rifiutato",
      "canceled": "Annullato"
    },
    "messages": {
      "eventMissingMessage": "Evento non trovato",
      "eventAcceptedMessage": "Hai accettato l'evento",
      "eventRejectedMessage": "Hai rifiutato l'evento",
      "eventCanceledMessage": "Hai annullato l'evento",
      "defaultOwnerNoPermissionTitle": "Proprietario predefinito senza permessi",
      "defaultOwnerNoPermissionMessage": "Il proprietario predefinito non ha i permessi richiesti",
      "defaultAssigneeNoPermissionTitle": "Assegnatario predefinito senza permessi",
      "defaultAssigneeNoPermissionMessage": "L'assegnatario predefinito non ha i permessi richiesti",
      "eventPropertiesNotUpdatedError": "Proprietà evento non aggiornate",
      "missingRequiredFields": "Campi obbligatori mancanti",
      "temporarilyUnableToRetrieveAllEventProperties": "Impossibile recuperare tutte le proprietà al momento",
      "theTeamHasBeenNotifiedPleaseRefreshOrTryAgainLater": "Il team è stato avvisato. Riprova più tardi.",
      "theFollowingEventFieldsWillBeCopiedToTheNewEvent": "I seguenti campi verranno copiati:",
      "youCanEditEventFieldsAfterCreation": "Puoi modificare i campi dopo la creazione.",
      "provideAnyInformationYouHave": "Fornisci tutte le informazioni disponibili",
      "theFollowingEventFieldsWillBeCopied": "I seguenti campi dell'evento verranno copiati nel nuovo evento:",
      "removedFromProperties": "Rimosso dalle proprietà:",
      "addedToProperties": "Aggiunto alle proprietà:",
      "requiredColon": "Obbligatorio:",
      "notRequired": "Non obbligatorio:",
      "thisActionAffectsStepApprovalStatus": "Questa azione influisce sullo stato di approvazione del passaggio",
      "manageApproverType": "Gestisci {{approverType}}",
      "approvalDeclined": "Approvazione rifiutata",
      "manageReviewers": "Gestisci revisori",
      "manageQualityApprovers": "Gestisci approvatori qualità",
      "manageOtherApprovers": "Gestisci altri approvatori",
      "manageApprovers": "Gestisci approvatori",
      "selectUsersForReviewerFeedback": "Seleziona gli utenti che forniranno feedback e suggerimenti sul modulo dell'evento.",
      "selectUsersForQualityApproval": "Seleziona gli utenti richiesti per l'approvazione finale e la firma del modulo dell'evento.",
      "selectUsersForOtherApproval": "Seleziona gli utenti responsabili dell'approvazione finale e della firma del modulo dell'evento.",
      "selectUsersForApproval": "Seleziona gli utenti responsabili dell'approvazione finale e della firma del modulo dell'evento.",
      "selectProductForEvent": "Seleziona il prodotto associato a questo evento.",
      "selectRootCauseForEvent": "Seleziona la causa principale di questo evento.",
      "riskCalculationDescription": "Il rischio è calcolato in base ai campi di probabilità e gravità di un evento. ",
      "linkSuppliersToEvent": "Collega i fornitori correlati a questo evento. ",
      "canceledOn": "Annullato il",
      "rejectedOn": "Rifiutato il",
      "closedEarlyOn": "Chiuso anticipatamente il",
      "cancelationReason": "Motivo di annullamento",
      "rejectionReason": "Motivo del rifiuto",
      "closeReason": "Motivo di chiusura",
      "missingQualityTypeApprover": "Approvatore qualità mancante",
      "requiredFieldsMustBeCompletedBeforeApprovalAndClosure": "I seguenti campi obbligatori devono essere completati prima che questo evento possa essere approvato e chiuso:",
      "editEventToFillMissingRequiredFields": "Aggiorna l'evento per compilare i campi obbligatori mancanti.",
      "removingApproversWarning": "La rimozione di questi approvatori cambierà il passaggio da in approvazione ad approvato.",
      "manageCollaborators": "Gestisci collaboratori",
      "selectUsersForCollaboration": "Seleziona gli utenti che possono completare o assegnare i passaggi dell'evento, nonché creare e gestire le attività.",
      "collaboratorsAdded": "Collaboratori aggiunti",
      "collaboratorsRemoved": "Collaboratori rimossi"
    },
    "modals": {
      "eventAcceptSubText": "Firma digitale per accettare l'evento",
      "eventCancelSubText": "Questa azione annullerà tutte le fasi dell'evento.",
      "eventRejectSubText": "Firma digitale per rifiutare l'evento",
      "approveStepSubText": "Inserisci la tua firma digitale per approvare il passaggio",
      "declineStepSubText": "Inserisci la tua firma digitale per rifiutare il passaggio",
      "closeEarlySubText": "Questa azione annullerà tutti i passaggi dell'evento e contrassegnerà l'evento come chiuso.",
      "reopenEventSubText": "Sei sicuro di voler riaprire questo evento?",
      "eventSuccessfullyClosed": "Evento {{eventCode}} chiuso con successo",
      "eventSuccessfullyReopened": "Evento {{eventCode}} riaperto con successo",
      "changeDueDateReasonPlaceholder": "Inserisci un motivo per modificare la data di scadenza...",
      "dueDateSuccessfullyUpdated": "Data di scadenza aggiornata con successo",
      "collaboratorsSuccessfullyUpdated": "Collaboratori aggiornati con successo"
    },
    "create": {
      "provideRequiredInformationToCreateAnEvent": "Fornisci le info richieste per creare un evento."
    },
    "tabs": {
      "details": "Dettagli"
    }
  },
  "tasks": {
    "labels": {
      "taskStatus": "Stato attività",
      "assignTo": "Assegna a",
      "reassignTo": "Riassegna a"
    },
    "actions": {
      "createTask": "Crea attività",
      "completeTask": "Completa attività",
      "reopenTask": "Riapri attività",
      "completeStep": "Completa passaggio",
      "actionStep": "Fase di azione",
      "revertStep": "Ripristina passaggio",
      "revertStepCompletion": "Annullare il completamento del passaggio?",
      "assignStep": "Assegna passaggio",
      "reassign": "Riassegna",
      "assign": "Assegna",
      "comment": "Commenta"
    },
    "modals": {
      "signOffToRevertCompletion": "Firma per annullare il completamento del passaggio \"{{stepLabel}}\"",
      "stepCompletionWasReverted": "Il completamento del passaggio \"{{stepLabel}}\" è stato annullato",
      "signOffToCompleteStep": "Firma per completare il passaggio \"{{stepLabel}}\"",
      "stepWasMarkedComplete": "Il passaggio \"{{stepLabel}}\" è stato contrassegnato come completato"
    },
    "messages": {
      "userReassigned": "Utente riassegnato",
      "userReassignedSuccessfully": "Utente riassegnato con successo.",
      "completeFormAndSendForReview": "Compila il modulo e invialo per revisione e approvazione quando è pronto.",
      "noFormAssociatedWithStep": "Non è associato alcun modulo a questo passaggio.",
      "thisFieldRequiredBeforeClosing": "Questo campo è obbligatorio prima di chiudere l'evento.",
      "cannotSendForApprovalUntil": "Questa risoluzione non può essere inviata per approvazione finché",
      "createAndAssignTasks": "Crea e assegna attività e monitorane i progressi.",
      "noTasksAssociatedWithStep": "Non ci sono attività associate a questo passaggio."
    }
  },
  "products": {
    "confirmations": {
      "deleteProductConfirmation": "Sei sicuro di voler eliminare \"{{productName}}\"?"
    }
  },
  "rootCauses": {
    "labels": {
      "rootCauses": "Cause radice"
    },
    "confirmations": {
      "deleteRootCauseConfirmation": "Sei sicuro di voler eliminare la causa radice \"{{rootCauseName}}\"?"
    }
  },
  "search": {
    "errors": {
      "searchFailed": "Impossibile recuperare i risultati della ricerca"
    }
  }
}
